import React from "react";
import { Alert, Col, Divider, Row, Tag, Typography } from "antd";

const sectionStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: 16,
  background: "#ffffff",
  minHeight: "100%",
};

const labelStyle = {
  color: "#64748b",
  fontSize: 12,
  marginBottom: 4,
};

const valueStyle = {
  color: "#0f172a",
  fontSize: 14,
  lineHeight: "20px",
};

const LeavePolicyReview = ({ summary, compact = false }) => {
  if (!summary) {
    return null;
  }

  return (
    <div style={ { padding: compact ? 16 : 24, background: "#f8fafc", marginBottom: compact ? 12 : 0 } }>
      <div style={ { marginBottom: compact ? 12 : 18 } }>
        <Typography.Title level={ compact ? 5 : 4 } style={ { marginBottom: 4 } }>
          { summary.title }
        </Typography.Title>
        <Typography.Text type="secondary">{ summary.description }</Typography.Text>
      </div>

      { !compact && (
        <Alert
          type="info"
          showIcon
          message="HR review before saving"
          description="Confirm that the allowed days, eligibility, and request rules match the policy you want employees and HR teams to follow."
          style={ { marginBottom: 16 } }
        />
      ) }

      { summary.warnings?.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message="Please double-check"
          description={
            <ul style={ { margin: "8px 0 0 18px", padding: 0 } }>
              { summary.warnings.map((warning) => (
                <li key={ warning }>{ warning }</li>
              )) }
            </ul>
          }
          style={ { marginBottom: 16 } }
        />
      ) }

      <Row gutter={ [16, 16] }>
        { summary.sections.map((section) => (
          <Col xs={ 24 } lg={ compact ? 24 : 12 } key={ section.title }>
            <div style={ sectionStyle }>
              <div style={ { display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center" } }>
                <Typography.Text strong>{ section.title }</Typography.Text>
                <Tag color="blue">{ section.items.length }</Tag>
              </div>
              <Divider style={ { margin: "12px 0" } } />
              <Row gutter={ [12, 14] }>
                { section.items.map((item) => (
                  <Col xs={ 24 } sm={ 12 } key={ `${section.title}-${item.label}` }>
                    <div style={ labelStyle }>{ item.label }</div>
                    <div style={ valueStyle }>{ item.value }</div>
                  </Col>
                )) }
              </Row>
            </div>
          </Col>
        )) }
      </Row>
    </div>
  );
};

export default LeavePolicyReview;
